module.exports = __webpack_public_path__ + "static/media/home_cabecalho_1920x324px.81fd95fa.png";